import { render } from "./ExamGridList.vue?vue&type=template&id=0c2272dc&scoped=true"
import script from "./ExamGridList.vue?vue&type=script&lang=js"
export * from "./ExamGridList.vue?vue&type=script&lang=js"

import "./ExamGridList.vue?vue&type=style&index=0&id=0c2272dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2272dc"]])

export default __exports__